import { useState, useMemo } from "react";
import { usePage } from "@inertiajs/react";
import AppLayout from "@/layout/AppLayout";
import BoardGameList from "@/components/app/BoardGameList";
import SyncBggButton from "@/components/app/SyncBggButton";

const TABS = [
  { key: "owned",        label: "Owned",        flag: "own" },
  { key: "want_to_play", label: "Want to Play",  flag: "want_to_play" },
  { key: "wishlist",     label: "Wishlist",      flag: "wishlist" },
];

export default function GameLibraryMine() {
  const { games, sync_enabled, bgg_synced_at } = usePage().props;
  const [activeTab, setActiveTab] = useState("owned");
  const lastSynced = bgg_synced_at ? new Date(bgg_synced_at) : null;

  const tabGames = useMemo(() => {
    const tab = TABS.find((t) => t.key === activeTab);
    return tab ? games.filter((g) => g[tab.flag]) : games;
  }, [games, activeTab]);

  const counts = useMemo(() => ({
    owned:        games.filter((g) => g.own).length,
    want_to_play: games.filter((g) => g.want_to_play).length,
    wishlist:     games.filter((g) => g.wishlist).length,
  }), [games]);

  return (
    <AppLayout>
      <div className="container py-8 max-w-4xl mx-auto">
        <div className="flex items-start justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold">My Library</h1>
            {lastSynced && (
              <p className="text-xs text-muted-foreground mt-1">
                Last synced {lastSynced.toLocaleDateString(undefined, {
                  month: "short", day: "numeric", year: "numeric"
                })}
              </p>
            )}
          </div>
          <SyncBggButton />
        </div>

        {/* Tabs */}
        <div className="flex items-center gap-1 border-b border-border mb-4">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors -mb-px ${
                activeTab === tab.key
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              {tab.label}
              <span className={`ml-1.5 text-xs rounded-full px-1.5 py-0.5 ${
                activeTab === tab.key
                  ? "bg-primary/15 text-primary"
                  : "bg-muted text-muted-foreground"
              }`}>
                {counts[tab.key]}
              </span>
            </button>
          ))}
        </div>

        <BoardGameList
          games={tabGames}
          mode="library"
          hasBgg={sync_enabled}
        />
      </div>
    </AppLayout>
  );
}
